import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Button, styled } from '@mui/material';

const Section = styled(Box)({
    position: 'relative',
    padding: '80px 0 44px',
    background: 'linear-gradient(135deg, #0066FF 0%, #6366F1 52%, #4F46E5 100%)',
    color: '#FFFFFF',
    textAlign: 'center',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '-28%',
        right: '-8%',
        width: '520px',
        height: '520px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.16) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-42%',
        left: '-12%',
        width: '620px',
        height: '620px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.10) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    '@media (max-width: 768px)': {
        padding: '60px 0 40px',
    },
    '@media (max-width: 480px)': {
        padding: '56px 0 32px',
    },
});

const Title = styled(Typography)({
    fontSize: '52px',
    fontWeight: 800,
    lineHeight: 1.1,
    letterSpacing: '-1.4px',
    marginBottom: '18px',
    '@media (max-width: 768px)': {
        fontSize: '34px',
        marginBottom: '14px',
    },
    '@media (max-width: 480px)': {
        fontSize: '28px',
    },
});

const Subtitle = styled(Typography)({
    fontSize: '21px',
    lineHeight: 1.6,
    opacity: 0.95,
    maxWidth: '940px',
    margin: '0 auto 44px',
    '@media (max-width: 768px)': {
        fontSize: '17px',
        marginBottom: '30px',
    },
    '@media (max-width: 480px)': {
        fontSize: '15px',
        marginBottom: '24px',
    },
});

const ButtonRow = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '14px',
    flexWrap: 'wrap',
    '@media (max-width: 480px)': {
        flexDirection: 'column',
    },
});

const CtaButton = styled(Button)({
    border: '2px solid rgba(255, 255, 255, 0.4)',
    color: '#FFFFFF',
    background: 'transparent',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '16px',
    padding: '13px 30px',
    borderRadius: '12px',
    '&:hover': {
        borderColor: '#FFFFFF',
        background: 'rgba(55, 38, 154, 0.27)',
        color: '#FFFFFF',
    },
    '@media (max-width: 480px)': {
        width: '100%',
    },
});

const GettingStartedSection = () => {
    return (
        <Section component="section" id="contact" aria-label="Getting started">
            <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
                <Typography
                    component="span"
                    sx={{
                        display: 'inline-block',
                        fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                        fontWeight: 700,
                        letterSpacing: '0.18em',
                        textTransform: 'uppercase',
                        color: '#FFFFFF',
                        bgcolor: 'rgba(17, 0, 255, 0.12)',
                        px: { xs: 1.75, sm: 2.25 },
                        py: 0.75,
                        borderRadius: 999,
                        mb: 2.5,
                    }}
                >
                    GETTING STARTED
                </Typography>

                <Title variant="h2">You'll be live in days, not months</Title>
                <Subtitle>
                    Therapists are using the app from day one. Admins configure session protocols without IT support.
                    No integration project, no historical data migration.
                </Subtitle>

                <ButtonRow>
                    <CtaButton 
                        component={Link} to="/demo" 
                        id="Book-demo-button"
                        data-gtm="Book-demo-button" 
                        variant="outlined"
                    >
                        Book a walkthrough
                    </CtaButton>
                    <CtaButton
                        component="a"
                        href="https://wa.me/919187644794"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outlined"
                    >
                        Talk to us on WhatsApp
                    </CtaButton>
                </ButtonRow>
            </Container>
        </Section>
    );
};

export default GettingStartedSection;
